import { stateDataLayer } from 'shared/modules';
import { getTitleOrEmpty } from './common';

export const sendAdvertViewEvent = (
  {
    make,
    model,
    year,
    title,
    price,
    id,
    location,
    category,
    is_new: isNew,
    is_sale_on_credit: isSaleOnCredit,
    hot_date: hotDate,
  },
  isSpare = false,
  setDataLayer,
) => {
  try {
    const priceUSD = price.find(priceObj => priceObj.currency === 'usd').value;
    const priceUAH = price.find(priceObj => priceObj.currency === 'uah').value;

    setDataLayer({
      pageType: 'Ad_card',
      adwId: id,
      car_price_usd: priceUSD,
      car_price_uah: priceUAH,
      car_name: title || '',
      car_brand: getTitleOrEmpty(make),
      car_model: getTitleOrEmpty(model),
      car_year: year,
      city: location && location.slug ? location.slug : '',
      price_category: '',
      type_car: getTitleOrEmpty(category),
      Condition_car: isNew ? 'новая' : 'с пробегом',
      payments_type: isSaleOnCredit ? 'кредит' : '',
      paymentState: hotDate ? 'paid' : 'free',
      adCategory: isSpare ? 'spares' : 'vehicle',
    });
  } catch (e) {
    //
  }
};



// WEBPACK FOOTER //
// ./src/shared/helpers/gtmEvents.js